import { useTranslation } from 'react-i18next';

import { Section } from '@/components/content-layout/section';
import { SectionHeader } from '@/components/content-layout/section-header';
import { CasesChartModule } from '@/components/dashboard/cases-chart-module';
import { UrgentCasesModule } from '@/components/dashboard/urgent-cases-module';

export function AdminDashboard() {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionHeader title={t('admin-dashboard-title')} element="h1" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CasesChartModule />
        <UrgentCasesModule />
      </div>
    </Section>
  );
}
